import { env } from "@/next.config";
import httpUtils from "@/utils/httpUtils";

export async function getToolboxList(config) {
    return httpUtils.get(`${env.API_VERSION}/toolboxes`, config);
}

export async function createToolbox(payload) {
    return httpUtils.post(`${env.API_VERSION}/toolboxes`, payload);
}

export async function updateToolbox(id, payload) {
    return httpUtils.put(`${env.API_VERSION}/toolboxes/${id}`, payload);
}

export async function deleteToolbox(id) {
    return httpUtils.delete(`${env.API_VERSION}/toolboxes/${id}`);
}

export async function getToolboxTags(config) {
    return httpUtils.get(`${env.API_VERSION}/toolbox-tags`, config);
} 